import '@one/design-tokens/css/regular/navify/light/variables.css';
import '@one/icons/dist/one-icons-filled.css';
import '@one/icons/dist/one-icons-outlined.css';
import '@one/roche-font/roche-font.css';
import '@one/web-components/dist/owc/owc.css';
import { createGlobalStyle } from 'styled-components';

export const defaultBreakpointWidth: string = '672px';

export const GlobalStyle = createGlobalStyle`

  :root {
    --default-breakpoint-width: ${defaultBreakpointWidth};
  }

  body {
    height: 100vh;
    width: 100vw;
    display: flex;
    flex-direction: column;
    margin: 0;
    font-family: 'Roche Sans', 'Roboto',  'Helvetica', 'Arial', sans-serif;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow: hidden;

    #root {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;

      main {
        background-color: var(--one-color-interaction-hover-contrast-lower);
        justify-content: center;

        // 100% height minus header height (48px)
        height: calc(100% - 48px);
      }
    }
  }

  * {
    box-sizing: border-box;
    /* color : var(--one-color-black-800); */
  }

  a {
    color: inherit; /* blue colors for links too */
    text-decoration: inherit; /* no underline */
  }

  /* UX: every disabled button shares the same background across the app */
  owc-button.owc-button--disabled {
    background-color: var(--one-color-interaction-default-intensity-low) !important;
  }

  owc-typography {
    
    /* By default, all text align to the left */
    text-align: left !important;

    &.text-center {
      text-align: center !important;
    }

    &.listItemPrefix {

      &.disabled {
        color: var(--one-color-foreground-intensity-medium);
      }

      &::before {
        content: '• ';
      }
    }

  }

  owc-list-item > div > div {
    white-space: unset !important;
  }

  /* ODSU lists/cards scroll internally by default (owc-list overflow-y:auto,
     owc-card content-wrapper max-height:100% + overflow:auto). That traps long
     lists inside their own box instead of letting the page / workflow-overlay
     scroll as a whole. Neutralise it so the outer scroll always wins. */
  owc-list {
    overflow: visible !important;
    max-height: none !important;
  }

  /* Exclude the workflow-overlay's own card: its content-wrapper IS the scroll
     owner for overlay steps, so neutralising it would stop every step from
     scrolling. Only inner content cards must give up their internal scroll. */
  owc-card:not(.sc-owc-workflow-overlay) .owc-card__content-wrapper {
    overflow: visible !important;
    max-height: none !important;
  }

`;
